export default __webpack_public_path__ + "static/media/left.f753311d.svg";